import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectEarlyAccess = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('is_early_access_enabled')(jsonQuery),
);
